var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaximize(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1352 4469 c-175 -29 -320 -107 -457 -244 -141 -141 -215 -281 -244 -465 -15 -90 -15 -2310 0 -2400 29 -184 103 -324 244 -465 142 -142 284 -216 471 -245 47 -7 442 -10 1239 -8 l1170 3 72 23 c252 77 442 236 548 457 76 157 78 175 83 613 l3 392 -215 0 -215 0 -3 -372 -3 -373 -32 -67 c-44 -94 -109 -160 -202 -206 l-75 -37 -1175 0 -1176 0 -67 32 c-94 44 -160 109 -206 202 l-37 75 0 1175 0 1176 32 67 c44 94 109 160 202 206 l75 37 373 3 373 3 0 214 0 215 -362 -1 c-200 -1 -387 -5 -416 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2990 4265 l0 -215 377 0 378 0 -668 -668 -667 -667 152 -153 153 -152 667 667 668 668 0 -378 0 -377 215 0 215 0 0 651 c0 487 -3 662 -12 693 -16 53 -81 118 -134 134 -31 9 -206 12 -693 12 l-651 0 0 -215z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaximize);
export default __webpack_public_path__ + "static/media/maximize.dce483d76df1d97d5a7c931a3bb1a993.svg";
export { ForwardRef as ReactComponent };